import { ReloadOutlined } from '@ant-design/icons'
import { Layout } from '@community_dev/pixels'
import { ProvisioningOverallStatus } from '@community_dev/types/lib/api/InfobipProvisioning'
import { Button, Card, Collapse, Descriptions, Typography } from 'antd'
import type { JSX } from 'react'

import { StatusTag } from './StatusTag'

import { ProvisioningStatus } from 'api/infobipProvisioning'

const { Panel } = Collapse

type StatusHeaderProps = {
  status: ProvisioningOverallStatus
}

const StatusHeader = ({ status }: StatusHeaderProps): JSX.Element => (
  <Layout alignItems="center" display="flex" gap="12px">
    <Typography.Text strong>Overall Status:</Typography.Text>
    <StatusTag status={status} />
  </Layout>
)

type OverviewProps = {
  provisioningStatus: ProvisioningStatus | undefined
  isFetching: boolean
  onRefresh: () => void
}

export const Overview = ({ provisioningStatus, isFetching, onRefresh }: OverviewProps): JSX.Element => {
  return (
    <Card
      extra={
        <Button icon={<ReloadOutlined spin={isFetching} />} onClick={onRefresh}>
          Refresh
        </Button>
      }
      title="Provisioning Overview"
    >
      <Collapse ghost>
        <Panel header={<StatusHeader status={provisioningStatus?.status ?? 'pending'} />} key="details">
          {provisioningStatus?.overview && (
            <Descriptions bordered column={3} size="small">
              <Descriptions.Item label="Total Numbers">{provisioningStatus.overview.totalNumbers}</Descriptions.Item>
              <Descriptions.Item label="Ready Numbers">{provisioningStatus.overview.readyNumbers}</Descriptions.Item>
              <Descriptions.Item label="Pending Numbers">
                {provisioningStatus.overview.pendingNumbers}
              </Descriptions.Item>
              <Descriptions.Item label="Error Numbers">{provisioningStatus.overview.errorNumbers}</Descriptions.Item>
              <Descriptions.Item label="Total Campaigns">
                {provisioningStatus.overview.totalCampaigns}
              </Descriptions.Item>
              <Descriptions.Item label="Error Campaigns">
                {provisioningStatus.overview.errorCampaigns}
              </Descriptions.Item>
            </Descriptions>
          )}
        </Panel>
      </Collapse>
    </Card>
  )
}
